import { Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from './routes/Landing.js';
import { Home } from './routes/Home.js';
import { Voice } from './routes/Voice.js';
import { Billing } from './routes/Billing.js';
import { Settings } from './routes/Settings.js';
import { AdminRanking } from './routes/AdminRanking.js';
import { AdminDashboard } from './routes/AdminDashboard.js';
import { Extension } from './routes/Extension.js';
import { ExtensionAuth } from './routes/ExtensionAuth.js';
import { History } from './routes/History.js';
import { Help } from './routes/Help.js';
import { Protected } from './components/Protected.js';
import { Layout } from './components/Layout.js';
import { AppGate } from './components/AppGate.js';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/extension-auth" element={<ExtensionAuth />} />
      <Route path="/app" element={<Protected><Layout /></Protected>}>
        <Route index element={<AppGate />} />
        <Route path="home" element={<Home />} />
        {/* Onboarding is now part of Home — legacy paths redirect. */}
        <Route path="onboarding" element={<Navigate to="/app/home" replace />} />
        <Route path="voice" element={<Voice />} />
        {/* Write and Radar collapsed into Home as tabs — keep routes for back-compat redirects. */}
        <Route path="write" element={<Navigate to="/app/home?tab=write" replace />} />
        <Route path="radar" element={<Navigate to="/app/home?tab=engage" replace />} />
        <Route path="radar/settings" element={<Navigate to="/app/home?tab=engage" replace />} />
        <Route path="extension" element={<Extension />} />
        <Route path="history" element={<History />} />
        <Route path="billing" element={<Billing />} />
        <Route path="settings" element={<Settings />} />
        <Route path="help" element={<Help />} />
        <Route path="admin" element={<AdminDashboard />} />
        <Route path="admin/ranking" element={<AdminRanking />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
